const style = {
  accordion: {
    width: '100%',
    backgroundColor: '#F5F5F5'
  },

  accordionPanel: {
    margin: 0,
    overflow: 'hidden'
  }
}

export default style
